/**
 * 현재 브라우저가 인앱 브라우저인지 감지하는 함수
 * @returns {boolean} 인앱 브라우저이면 true, 아니면 false
 */
export const isInAppBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // 카카오톡
  if (/KAKAOTALK/i.test(userAgent)) return true;
  
  // 인스타그램
  if (/Instagram/i.test(userAgent)) return true;
  
  // 페이스북
  if (/FBAN|FBAV/i.test(userAgent)) return true;
  
  // 네이버 앱
  if (/NAVER/i.test(userAgent)) return true;
  
  // 라인
  if (/Line/i.test(userAgent)) return true;
  
  return false;
};

/**
 * 현재 URL을 외부 브라우저로 여는 함수
 */
export const openInExternalBrowser = () => {
  // 현재 URL을 저장
  const currentUrl = window.location.href;
  
  // 안드로이드 기기 감지
  if (/Android/i.test(navigator.userAgent)) {
    // 안드로이드에서 기본 브라우저로 열기 (특정 브라우저 지정하지 않음)
    window.location.href = `intent://${window.location.host}${window.location.pathname}${window.location.search}#Intent;scheme=https;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;end`;
  } 
  // iOS 기기 감지
  else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    // iOS에서는 Safari로 열기
    window.location.href = currentUrl;
  } 
  // 기타 기기
  else {
    window.open(currentUrl, '_system');
  }
};

/**
 * 현재 기기가 모바일인지 감지하는 함수
 * @returns {boolean} 모바일 기기이면 true, PC이면 false
 */
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // 모바일 기기 감지
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}; 